export default "__VITE_ASSET__B59RMMrc__"